import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import Button from 'Components/UI/Button';
import React from 'react';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { IconButton } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';

export default function FAQButton({ link, text = '' }) {
  const { loadModalCollectionByLink } = useModalContext();

  const handleClickViewFAQ = async () => {
    await loadModalCollectionByLink(link.url());
  };

  if (text === '') {
    return (<IconButton
      icon={HelpOutlineIcon}
      color={'primary'}
      size={'small'}
      onClick={handleClickViewFAQ}
    />);
  }

  return <>
    <Button
      round
      variant={'text'}
      color={'primary'}
      onClick={handleClickViewFAQ}
      startIcon={<HelpOutlineIcon />}
    >
      {text}
    </Button>
  </>;
}
